import { css } from '@emotion/core';
import { Collapse, Icon } from 'antd';
import Link from 'next/link';
import React from 'react';

import Button from '@/src/shared/components/Button';
import Heading from '@/src/shared/components/Heading';
import { bp, colors } from '@/styles';
import Sanitize from '@/src/shared/components/Sanitize';

const { Panel } = Collapse;

const styles = {
  collapse: css`
    margin-bottom: 16px;
    border: none;
    background-color: white;
    box-shadow: 0 6px 12px 0 rgba(35, 32, 32, 0.1);
    border-radius: 2px;
    margin-left: -16px;
    margin-right: 16px;

    @media ${bp.md} {
      margin-left: 0;
      margin-right: 0;
    }

    .ant-collapse-item {
      .ant-collapse-header {
        display: flex;
        align-items: baseline;
        padding: 24px 16px !important;
        .ant-collapse-arrow {
          font-size: 20px !important;
          position: relative;
          left: 0;
          margin-right: 18px;
          transform: none;
        }
        @media ${bp.md} {
          align-items: center;
          padding: 24px 32px !important;
          .ant-collapse-arrow {
            font-size: 22px !important;
          }
        }
      }
      .ant-collapse-content {
        background-color: transparent !important;
        border-top: none !important;

        .ant-collapse-content-box {
          padding: 0px;
        }
      }
    }
    .ant-collapse-item-active {
      .ant-collapse-header {
        h3 {
          color: ${colors.primaryRed} !important;
        }
      }
    }
  `,
  content: css`
    font-size: 16px;
    color: ;
  `,
  iconMinus: css`
    color: ${colors.primaryRed} !important;
  `,
  iconPlus: css`
    color: ${colors.primaryBlue} !important;
  `,
  panelHeader: css`
    padding: 24px 16px;
    @media ${bp.xl} {
      padding: 24px 32px;
    }
  `,
  panelDescription: css`
    font-size: 16px;
    line-height: 28px;
    border-bottom: 1px solid ${colors.accentGrayLight};
    padding: 0 16px 32px 16px;
    @media ${bp.xl} {
      padding: 0 100px 32px 32px;
    }
  `,
  subDescription: css`
    font-size: 16px;
    line-height: 24px;
    background-color: ${colors.accentGrayUltralight}25;
    padding: 16px 16px 24px 16px;
    @media ${bp.xl} {
      padding: 32px 100px 32px 32px;
    }
  `,
  button: css`
    margin: 1.6rem 0 0;
  `,
};

const CommitteeCard = props => {
  const {
    committee: { Committee, CommitteeCode, CommitteeDescription, subCommittees },
  } = props;

  return (
    <Collapse
      css={styles.collapse}
      className="outerpanel"
      expandIcon={({ isActive }) => (
        <Icon
          css={styles[isActive ? 'iconMinus' : 'iconPlus']}
          type={isActive ? 'minus' : 'plus'}
        />
      )}
    >
      <div>
        <Heading type={2} theme="primaryGray" css={styles.panelHeader} weight="bolder">
          <Link
            href="/policy/committees/[slug]"
            as={`/policy/committees/${CommitteeCode}`}
            passHref
          >
            <a>{Committee}</a>
          </Link>
        </Heading>
        <div css={styles.panelDescription}>
          <Sanitize>
          {CommitteeDescription}
          </Sanitize>
          <div css={styles.button}>
            <Button
              link
              href="/policy/committees/[slug]"
              as={`/policy/committees/${CommitteeCode}`}
              theme="default"
              size="small"
            >
              See Details
            </Button>
          </div>
        </div>
      </div>
      {subCommittees.map(c => (
        <Panel
          key={c.CommitteeCode}
          header={
            <Heading type={3} weight="bolder" theme="primaryBlue">
              {c.Committee}
            </Heading>
          }
        >
          <div css={styles.subDescription}>
            {c.CommitteeDescription}

            <div css={styles.button}>
              <Button
                link
                href="/policy/committees/[slug]"
                as={`/policy/committees/${c.CommitteeCode}`}
                theme="default"
                size="small"
              >
                See Details
              </Button>
            </div>
          </div>
        </Panel>
      ))}
    </Collapse>
  );
};

export default CommitteeCard;
